module.exports = __webpack_public_path__ + "img/10stars.576cbfad.jpg";